"use client";

import { useEffect, useState } from "react";
import { App } from "antd";
import { RefreshCw } from "lucide-react";

export default function UpdatePrompt() {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
  const { notification } = App.useApp();

  useEffect(() => {
    // Check if service worker is supported
    if (!("serviceWorker" in navigator)) return;

    // Listen for service worker updates
    const checkForUpdates = async () => {
      const registration = await navigator.serviceWorker.ready;

      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            setWaitingWorker(newWorker);
            showUpdateNotification();
          }
        });
      });
    };

    checkForUpdates();
  }, []);

  const showUpdateNotification = () => {
    setTimeout(() => {
      notification.info({
        message: "Cập nhật mới",
        description: "Có phiên bản mới của ứng dụng. Nhấn để cập nhật.",
        icon: <RefreshCw className="text-primary" />,
        btn: (
          <button
            onClick={handleUpdate}
            className="bg-primary text-white px-3 py-1 rounded"
          >
            Cập nhật
          </button>
        ),
        duration: 0,
        placement: "bottomRight",
      });
    }, 0);
  };

  const handleUpdate = () => {
    if (!waitingWorker) return;

    waitingWorker.postMessage({ type: "SKIP_WAITING" });

    waitingWorker.addEventListener("statechange", () => {
      if (waitingWorker.state === "activated") {
        window.location.reload();
      }
    });
  };

  return null;
}